import { languageMap } from ".."

languageMap.erlang = {
	comments: {
		line: "%",
	},
}
